<template>
  <div class="pagination__bullet" :class="{'-active': active}">
      <span
          @click="$emit('changePage')"
          @keydown="$emit('changePage')"
          class="icon-check-before"></span>
  </div>
</template>

<script>

import { useViewStore } from '@/stores/view';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pagination',
  props: {
    active: Boolean,
  },
  setup() {
    const view = useViewStore();
    return {
      view,
    };
  },
};
</script>
